/**
 * Color Theme
 * App-wide color definitions - Wealfi Brand Colors
 */

// Wealfi Brand Colors
export const brand = {
  green: '#71B352',
  greenDark: '#5B8A3C',
  greenLight: '#E8F5E0',
  dark: '#3D4543',
  orange: '#D97234',
  orangeLight: '#FFF3EB',
  gray: '#6B7280',
  grayLight: '#9CA3AF',
  background: '#FAFBFC',
  white: '#FFFFFF',
};

export const colors = {
  // Primary (Wealfi Green)
  primary: brand.green,
  primaryDark: brand.greenDark,
  primaryLight: brand.greenLight,

  // Secondary (Wealfi Orange)
  secondary: brand.orange,
  secondaryLight: brand.orangeLight,

  // Background
  background: brand.white,
  backgroundSecondary: brand.background,
  backgroundTertiary: '#F3F4F6',

  // Text
  text: brand.dark,
  textSecondary: brand.gray,
  textTertiary: brand.grayLight,

  // Messages (Chat)
  userMessage: brand.green,
  aiMessage: brand.background,
  userMessageText: brand.white,
  aiMessageText: brand.dark,

  // Status
  success: brand.green,
  error: '#EF4444',
  warning: brand.orange,
  info: '#3B82F6',

  // Borders
  border: '#E5E7EB',
  borderLight: '#F3F4F6',

  // Rate Limit
  rateLimitWarning: brand.orange,
  rateLimitError: '#EF4444',
  rateLimitGood: brand.green,

  // Sidebar
  sidebar: {
    background: brand.background,
    backgroundHover: '#F3F4F6',
    backgroundActive: brand.greenLight,
    border: '#E5E7EB',
    text: brand.dark,
    textSecondary: brand.gray,
    textMuted: brand.grayLight,
    accent: brand.green,
    userBadge: brand.greenLight,
  },

  // Cards
  card: {
    background: brand.white,
    border: '#E5E7EB',
    shadow: 'rgba(0, 0, 0, 0.05)',
  },

  // Buttons
  button: {
    primary: brand.green,
    primaryText: brand.white,
    secondary: brand.white,
    secondaryText: brand.green,
    secondaryBorder: brand.green,
    disabled: '#D1D5DB',
    disabledText: '#9CA3AF',
  },

  // Input
  input: {
    background: brand.white,
    border: '#E5E7EB',
    borderFocus: brand.green,
    placeholder: brand.grayLight,
    text: brand.dark,
  },

  // Premium/Pro badges
  premium: {
    background: brand.orangeLight,
    text: brand.orange,
    badge: brand.orange,
  },
};

// Dark mode colors (for future implementation)
export const darkColors = {
  ...colors,
  background: '#111827',
  backgroundSecondary: '#1F2937',
  backgroundTertiary: '#374151',
  text: brand.white,
  textSecondary: '#9CA3AF',
  aiMessage: '#1F2937',
  border: '#374151',
  card: {
    background: '#1F2937',
    border: '#374151',
    shadow: 'rgba(0, 0, 0, 0.3)',
  },
  input: {
    background: '#1F2937',
    border: '#374151',
    borderFocus: brand.green,
    placeholder: '#6B7280',
    text: brand.white,
  },
  sidebar: {
    background: '#1F2937',
    backgroundHover: '#374151',
    backgroundActive: '#374151',
    border: '#374151',
    text: brand.white,
    textSecondary: '#9CA3AF',
    textMuted: '#6B7280',
    accent: brand.green,
    userBadge: '#374151',
  },
};
